import styled from 'styled-components';

export const StyledMultiSelectionPanel = styled.div`
  width: 100%;
  min-width: 0;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 16px;
  box-sizing: border-box;
`;

export const StyledMultiSelectionSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  gap: 0;
`;

export const StyledMultiSelectionSectionTitle = styled.div.attrs({
  className: 'respark_multi-selection-section-title',
})`
  font-family: Poppins, system-ui, sans-serif;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.3;
  color: var(--primary-text-color, #1f2a44);
  margin: 0 0 4px;
  width: 100%;
`;

export const StyledMultiSelectionActionsColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 6px;
  width: 100%;
  min-width: 0;
`;
